import { useState, useCallback } from "react";
import { toast } from "react-toastify";
import useFetchApi from "hooks/useFetchApi";

export default function useDownload(documentId) {
  const [fetchApi] = useFetchApi();
  const [isLoading, setIsLoading] = useState(false);

  const handleDownload = useCallback(async () => {
    if (isLoading) return;
    setIsLoading(true);
    try {
      const { url } = await fetchApi(`document/get-url/${documentId}`);
      window.location = url;
    } catch (err) {
      toast.error(
        err?.message ?? "Une erreur est survenue lors du téléchargement.",
      );
    } finally {
      setIsLoading(false);
    }
  }, [fetchApi, documentId, isLoading]);

  const handleView = useCallback(async () => {
    if (isLoading) return;
    setIsLoading(true);
    // Open a blank tab synchronously within the user gesture to avoid popup blockers.
    // After the async fetch we update its location to the signed URL.
    const newTab = window.open("", "_blank");
    try {
      const { url } = await fetchApi(
        `document/get-url/${documentId}?view=true`,
      );
      if (newTab) {
        newTab.location.href = url;
      }
    } catch (err) {
      newTab?.close();
      toast.error(
        err?.message ??
          "Une erreur est survenue lors de l'ouverture du document.",
      );
    } finally {
      setIsLoading(false);
    }
  }, [fetchApi, documentId, isLoading]);

  return { handleDownload, handleView, isLoading };
}
